<template>
  <div class="auth-section">
    <div class="panel-header">
      <span class="panel-bar"></span>
      <span class="panel-title">实名认证</span>
    </div>
    <!-- 黄色提示条（新增） -->
    <div class="auth-tip" role="note" aria-label="提示">
      <img class="auth-tip-icon" src="@/assets/提示说明 1.png" alt="" />
      <div class="auth-tip-text">
        您上次提交的信息审核未通过，请重新提交
      </div>
    </div>
    <!-- 展示态 -->
    <div v-if="!isEditing" class="form">
      <div class="row">
        <div class="label">
          <span class="req">*</span>
          姓名
        </div>
        <div class="value">
          <span class="text">{{ displayName }}</span>
          <img class="meta-icon" @click="enterEdit" src="@/assets/编辑 1@2x.png" alt="" />
        </div>
      </div>

      <div class="row">
        <div class="label">身份证号</div>
        <div class="value">
          <span class="text">{{ displayIdNo }}</span>
          <button class="link" type="button" @click="enterEdit">修改</button>
        </div>
      </div>

      <div class="row">
        <div class="label">证书</div>
        <div class="value value-col">
          <div class="portfolio-grid">
            <div v-for="(img, i) in portfolioImages" :key="img + i" class="portfolio-item">
              <img :src="img" alt="" />
            </div>
          </div>

        </div>
      </div>
      <button class="link2" type="button" @click="enterEdit">修改</button>
    </div>

    <!-- 编辑态（如 UI：输入框 + 上传 + 保存并提交） -->
    <div v-else class="edit-form">
      <div class="row">
        <div class="label">
          <span class="req">*</span>
          姓名
        </div>
        <div class="value">
          <el-input v-model="editForm.name" placeholder="请输入姓名" />
        </div>
      </div>

      <div class="row">
        <div class="label">身份证号</div>
        <div class="value">
          <el-input v-model="editForm.idNo" placeholder="请输入身份证号" />
        </div>
      </div>

      <div class="row">
        <div class="label">证书</div>
        <div class="value value-col">
          <div class="portfolio-grid">
            <!-- 上传卡片 -->
            <div class="upload-card" role="button" tabindex="0" @click="triggerFile" @keydown.enter="triggerFile">
              <div class="plus">+</div>
              <div class="upload-text">上传图片</div>
              <input ref="fileInputRef" class="file-input" type="file" accept="image/*" multiple
                @change="onFilesChange" />
            </div>

            <!-- 已上传的图片（可删除） -->
            <div v-for="(img, i) in editForm.certImages" :key="img + i" class="portfolio-item is-editable">
              <img :src="img" alt="" />
              <button class="remove" type="button" @click="removeImage(i)">×</button>
            </div>
          </div>


        </div>
      </div>
      <div class="edit-actions">
        <button class="save-btn" type="button" @click="onSaveSubmit">保存并提交</button>
        <!-- <button class="cancel-btn" type="button" @click="onCancelEdit">取消</button> -->
      </div>
    </div>

    <!-- 提交弹窗（等待后台审核） -->
    <el-dialog v-model="dialogs.submitVisible" width="384px" class="submit-dialog" :show-close="false"
      :close-on-click-modal="false" :teleported="false" align-center>
      <div class="submit-body">
        <div class="clock-wrap">
          <img class="icon" src="@/assets/Frame 9800@2x.png" alt="" />
          <!-- <div class="clock-circle">
            <div class="clock-hand"></div>
            <div class="clock-hand short"></div>
          </div> -->
        </div>

        <div class="submit-title">等待后台审核</div>
        <div class="submit-desc">修改信息已提交，等待后台审核</div>

        <button class="submit-close-btn" type="button" @click="dialogs.submitVisible = false">
          关闭
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { computed, reactive, ref, watch } from 'vue'
import { ElMessage } from 'element-plus'

const props = defineProps({
  profile: {
    type: Object,
    default: () => ({
      nickname: '',
      email: '',
      phone: ''
    })
  }
})

const emit = defineEmits(['edit', 'update-profile'])

/** 展示用图片（你原来的示例） */
const portfolioImages = ref([
  'https://images.unsplash.com/photo-1558655146-9f40138edfeb?auto=format&fit=crop&w=600&q=80',
  'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?auto=format&fit=crop&w=600&q=80',
  'https://images.unsplash.com/photo-1559028012-481c04fa702d?auto=format&fit=crop&w=600&q=80'
])

/** 状态 */
const isEditing = ref(false)
const dialogs = reactive({
  submitVisible: false
})

/** 编辑表单（进入编辑时从展示态拷贝一份） */
const editForm = reactive({
  name: '李***',
  idNo: '123456@126.com',
  certImages: []
})

/** 你真实数据接入时，可用 props.profile 去替换这两处 display */
const displayName = computed(() => editForm.name || '—')
const displayIdNo = computed(() => editForm.idNo || '—')

/** 进入编辑 */
function enterEdit() {
  // 如你还需要通知父组件“进入编辑”，保留 emit
  emit('edit', 'auth')

  // 初始化编辑数据：从当前展示拷贝
  editForm.certImages = [...portfolioImages.value]
  isEditing.value = true
}

/** 取消编辑：回到展示态，不提交 */
// function onCancelEdit() {
//   isEditing.value = false
// }

/** 上传 */
const fileInputRef = ref(null)

function triggerFile() {
  fileInputRef.value?.click()
}

function onFilesChange(e) {
  const files = Array.from(e.target.files || [])
  if (!files.length) return

  files.forEach((f) => {
    if (!f.type?.startsWith('image/')) return
    const url = URL.createObjectURL(f)
    editForm.certImages.push(url)
  })

  // 允许选择同一文件再次触发 change
  e.target.value = ''
}

function removeImage(index) {
  editForm.certImages.splice(index, 1)
}

/** 保存并提交 */
function onSaveSubmit() {
  if (!editForm.name?.trim()) {
    ElMessage.warning('请输入姓名')
    return
  }

  // 这里你可加身份证号校验规则
  // if (!editForm.idNo?.trim()) { ... }

  // 1) 本地更新展示数据（模拟保存成功）
  portfolioImages.value = [...editForm.certImages]

  // 2) 通知父组件（你接接口时用这个 payload）
  emit('update-profile', {
    name: editForm.name,
    idNo: editForm.idNo,
    certificates: editForm.certImages
  })

  // 3) 关闭编辑态 + 打开“等待审核”弹窗
  isEditing.value = false
  dialogs.submitVisible = true
}

/**
 * 可选：当外部 profile 变化时同步（如果你以后把 name/idNo 放到 props.profile）
 * 目前这里只做示例，不强制依赖。
 */
watch(
  () => props.profile,
  () => {
    // 如果你把真实字段接到 props.profile 里，可在这里同步展示值
  },
  { deep: true }
)
</script>

<style scoped lang="scss">
.auth-section {
  width: 100%;
}

:deep(.auth-tip) {
  // margin: 0 auto;
  width: 300px;
  height: 32px;
  margin-bottom: 20px;
  background: #FFF2EA;
  border-radius: 4px 4px 4px 4px;
  font-weight: 400;
  font-size: 13px;
  color: #DF7606;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.auth-tip .auth-tip-icon) {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  margin-right: 4px;

}

.value-col {
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
}

/* ====== 证书区 ====== */
.portfolio-grid {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 720px) {
    width: 100%;
  }
}

.portfolio-item {
  width: 150px;
  height: 90px;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  overflow: hidden;
  position: relative;
  background: #fff;
}

.portfolio-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.portfolio-item.is-editable .remove {
  position: absolute;
  right: 6px;
  top: 6px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 0;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  line-height: 22px;
  cursor: pointer;
}

/* 上传卡片 */
.upload-card {
  width: 90px;
  height: 90px;
  border-radius: 8px;
  border: 1px dashed #d6d6d6;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
}

.plus {
  font-size: 22px;
  line-height: 1;
  color: #7a7a7a;
  margin-bottom: 6px;
}

.upload-text {
  font-size: 12px;
  color: #9a9a9a;
}

.file-input {
  display: none;
}

/* ====== Element Plus input 统一高度 ====== */
:deep(.el-input) {
  height: 40px;
  width: 674px;
  max-width: 100%;
}

:deep(.el-input .el-input__wrapper) {
  border-radius: 8px;
}

/* ====== 头部 ====== */
.panel-header {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 34px;
}

.panel-bar {
  width: 3px;
  height: 16px;
  border-radius: 2px;
  background: #4caf50;
}

.panel-title {
  font-weight: 500;
  font-size: 18px;
  color: #495060;
}

/* ====== 展示态样式（沿用你原来的） ====== */
.form {
  padding-left: 22px;
}

.edit-form {
  padding-left: 22px;
}

.row {
  display: flex;
  align-items: center;
  min-height: 44px;
  margin: 10px 0;
}

.label {
  width: 72px;
  font-weight: 500;
  font-size: 14px;
  color: #303133;
  display: inline-flex;
  align-items: center;
  justify-content: right;
  margin-right: 28px;
  gap: 6px;
}

.meta-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.req {
  color: #e74c3c;
  font-weight: 700;
  transform: translateY(-1px);
}

.value {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}

.text {
  font-size: 16px;
  color: #2b2f33;
}

.link2 {
  margin-left: 102px;
  margin-top: 24px;
  width: 120px;
  height: 44px;
  border-radius: 4px;
  border: 1px solid #4caf50;
  font-weight: 400;
  font-size: 16px;
  color: #4caf50;
  background: #fff;
  cursor: pointer;
}

.link {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  font-weight: 400;
  font-size: 16px;
  color: #4caf50;
}

.link:hover {
  text-decoration: underline;
}

/* 编辑态按钮 */
.edit-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 102px;
  margin-top: 24px;
}

.save-btn {

  width: 120px;
  height: 44px;
  border-radius: 4px;
  border: 0;
  background: #4caf50;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.cancel-btn {
  width: 88px;
  height: 44px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  background: #fff;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
}

/* ====== 提交弹窗（仿 UI） ====== */
.submit-dialog :deep(.el-dialog) {
  border-radius: 8px;
}

.submit-body {
  padding: 0px 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.clock-wrap {
  // margin-top: 6px;
  margin-bottom: 28px;

  .icon {
    width: 100px;
    height: 100px;
  }
}

.clock-circle {
  width: 74px;
  height: 74px;
  border-radius: 50%;
  background: #57c35a;
  position: relative;
}

.clock-hand {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 22px;
  height: 4px;
  background: #fff;
  border-radius: 3px;
  transform-origin: 2px 2px;
  transform: translate(-2px, -2px) rotate(0deg);
}

.clock-hand.short {
  width: 14px;
  transform: translate(-2px, -2px) rotate(90deg);
}

.submit-title {
  font-weight: 400;
  font-size: 20px;
  color: #2E323E;
  margin-bottom: 6px;
}

.submit-desc {
  font-weight: 400;
  font-size: 16px;
  color: #9899A2;
  margin-bottom: 48px;
}

.submit-close-btn {
  width: 112px;
  height: 41px;
  background: linear-gradient(39deg, #4CAF50 0%, #91DF35 100%);
  box-shadow: 2px 2px 4px 0px rgba(24, 144, 255, 0.1);
  border-radius: 200px 200px 200px 200px;
  font-size: 15px;
  color: #FFFFFF;
  cursor: pointer;
  border: none;
}
</style>